import * as React from "react";

export const SsoEmpty = () => {
    return (
        <div></div>
    );
};